import axios from 'axios'

async function create_template(dispatch,token,templates,add_template,add_templates,setOpen,setMessage,data,setLoading,navigate){
try {
    setLoading(true)

    const addTemplate = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}add-template/`,data,{
         headers:{
                "Content-Type":"application/json",
                "Authorization":`Bear ${token}`
            }
     }).catch(err=>{console.log(err)})

    if (addTemplate?.status == 200 && addTemplate?.data?.success) {

        const newData = [...templates,addTemplate?.data.template]

        await dispatch(add_templates(newData))
        await dispatch(add_template(addTemplate?.data.template))
        localStorage.setItem("iTest_template",JSON.stringify(addTemplate?.data?.template))

        setMessage("Template assessment created")
        setOpen(true)
        setLoading(false)
        navigate("/templateInfo")

    }else{
      setMessage(addTemplate?.data?.message)
      setOpen(true)
      setLoading(false)
    }
} catch (error) {
    console.log(error)
}

}

export default create_template